'use strict'

export function initializeChart(...args) {
  const element = args[0]
  const Chart = args[1]
  const params = args.slice(2)
  params.splice(1, 0, element)

  return new Chart(...params)
}
